import React, { FC, Suspense, lazy } from 'react'
import FullPageLoader from '../../components/full-page-loader/FullPageLoader'

const OberoyTheme = lazy(() => import('./OberoyTheme'))

const Oberoy: FC = ({ children }) => {
  const isSSR = typeof window === 'undefined'

  return (
    <React.Fragment>
      {!isSSR && (
        <Suspense fallback={<FullPageLoader />}>
          <OberoyTheme>{children}</OberoyTheme>
        </Suspense>
      )}
    </React.Fragment>
  )
}

export { Oberoy }
